var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"priority-tag"},[_c('b',{class:'tag-' + _vm.priority},[_vm._v(_vm._s(_vm.priority))]),_c('span',[_vm._v(_vm._s(_vm.$t(`todos.priorities.${_vm.priority}`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }